import { useEffect, useState } from "react";
import Header from "./header";
import Main from "./main";

export default function Layout() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let token = localStorage.getItem("token");
    if (!token) {
      setLoading(false);
      return;
    }
    setLoading(false);
  }, []);
  return (
    <div>
      {loading ? (
        <p></p>
      ) : (
        <>
          <div className="w-full overflow-hidden">
            <Main />
          </div>
        </>
      )}
    </div>
  );
}
